import { CompetenceTypeDataService } from "../../core/competencetypes.dataservice";
import { CompetenceGroupsService } from "../../core/competencegroups.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { CompetenceTypes } from "./competencetypes.component";
import { EditCompetenceType } from "./competencetype.edit.component";
import { CompetenceType } from "./competencetype.component";

/**
 * This state displays all Competence Types
 */
export const competenceTypesState: Ng2StateDeclaration = {
    name: "app.settings.competencetypes",
    url: "/competencetypes",
    views: {
        "main-view@app": {
            component: CompetenceTypes
        }
    },
    resolve: {
        competenceTypes: ["competenceTypeDataService", (competenceTypeDataService: CompetenceTypeDataService) => {
            return competenceTypeDataService.getAll();
        }],
        competenceGroups: ["competenceGroupsService", function (competenceGroupsService: CompetenceGroupsService) {
            return competenceGroupsService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Competence Type
 */
export const newCompetenceTypeState: Ng2StateDeclaration = {
    name: "app.settings.competencetypes.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditCompetenceType
        }
    },
    resolve: {
        competenceType: function () {
            return <Nema.Crew.Model.CompetenceType>{
                Id: -1, Name: "", Active: true, SortTag: "", CompetenceGroup: null, CompetenceGroupId: null, CompetenceRequirementCompetenceTypes: null, CompetenceRequirements: null, CompetenceTypeCVMappingCompetenceTypes: null, PersonCompetences: null, WarningTimeNrMonths: 0, Description: ""
            };
        },
        competenceGroups: ["competenceGroupsService", function (competenceGroupsService: CompetenceGroupsService) {
            return competenceGroupsService.getAll();
        }],
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Competence Type
 */
export const editCompetenceTypeState: Ng2StateDeclaration = {
    name: "app.settings.competencetypes.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditCompetenceType
        }
    },
    resolve: {
        competenceType: ["competenceTypeDataService", "$stateParams", function (competenceTypeDataService: CompetenceTypeDataService, $stateParams) {
            return competenceTypeDataService.get($stateParams.id);
        }],
        competenceGroups: ["competenceGroupsService", function (competenceGroupsService: CompetenceGroupsService) {
            return competenceGroupsService.getAll();
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Competence Type Details state
 */
export const competenceTypeState: Ng2StateDeclaration = {
    name: "app.settings.competencetypes.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: CompetenceType
        }
    },
    resolve: {
        competenceType: ["competenceTypeDataService", "$stateParams", function (competenceTypeDataService: CompetenceTypeDataService, $stateParams) {
            return competenceTypeDataService.get($stateParams.id);
        }],
        competenceGroups: ["competenceGroupsService", function (competenceGroupsService: CompetenceGroupsService) {
            return competenceGroupsService.getAll();
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencetypes/competencetypes.states.ts